module.exports = __webpack_public_path__ + "img/7C.e40a554f.jpg";